import { SelectInputV2, SelectInputV2Props } from '@frontend/components/basic-forms';
import { ScreenTrigger } from '@frontend/wizard/types';
import React from 'react';

const ID = 'screen-trigger-select';

export const ScreenTriggerSelect = (props: Omit<SelectInputV2Props<ScreenTrigger>, 'options'>) => {
    return (
        <SelectInputV2
            {...props}
            id={props.id || ID}
            isClearable={props.isClearable}
            label={props.label || 'Trigger'}
            options={Object.entries(ScreenTrigger).map((c) => ({ value: c[1], label: c[1] }))}
            value={props.value}
            onSelect={props.onSelect}
        />
    );
};
